import * as fromDatatype from '../datatype-library/index';

export interface app_registry_main_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  registry_key: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  module_code: fromDatatype.VarcharDatatypeInterface;
  function_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_table: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_key: fromDatatype.VarcharDatatypeInterface;
  entity_line_table: fromDatatype.VarcharDatatypeInterface;
  entity_line_key: fromDatatype.VarcharDatatypeInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_registry_main_RowClass implements app_registry_main_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  registry_key: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  module_code: fromDatatype.VarcharDatatypeInterface;
  function_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_table: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_key: fromDatatype.VarcharDatatypeInterface;
  entity_line_table: fromDatatype.VarcharDatatypeInterface;
  entity_line_key: fromDatatype.VarcharDatatypeInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


